<template>
  <widget-wrapper
    :id="configItem.chartId"
    :title="chartAttr.title"
    :subTitle="chartAttr.subtitle"
    :addtxt="chartAttr.addtxt"
    :info="chartAttr.info"
    :empty="empty"
    :loading="loadingbar"
    @ctrl="ctrlClick"
    class="custom1 instance-map"
  >
    <slot>
      <div style="display: flex; flex-direction: column; height: 100%">
        <c-scroll style="height: calc(100% - 36px)">
          <div class="grid-box">
            <template v-for="(item, index) in lists" :key="index">
              <div
                class="rect"
                :style="'opacity:' + opacity(item.value)"
                v-lego-tooltip="item.tooltip"
              ></div>
            </template>
          </div>
        </c-scroll>
        <div class="legend-box" style="width: 100%; margin-top: auto">
          <ul style="display: flex">
            <li class="legend" style="opacity: 0.2"></li>
            <li class="legend" style="opacity: 0.4"></li>
            <li class="legend" style="opacity: 0.6"></li>
            <li class="legend" style="opacity: 0.8"></li>
            <li class="legend" style="opacity: 1"></li>
          </ul>
          <ul style="display: flex">
            <li v-for="(item, index) in legend" :key="index" class="legendtxt">
              {{ $filters.comma(parseFloat(Number(item)).toFixed(2)) }}
            </li>
          </ul>
        </div>
      </div>
    </slot>
  </widget-wrapper>
</template>
<script>
import widgetWrapper from '@/components/scpm/widgets/common/widgetWrapperScpm';
import widgetMixin from './widgetMixin';
import { getWidgetData } from '../serviceApi';

export default {
  name: 'InstanceMapWidget',
  components: { widgetWrapper },
  mixins: [widgetMixin],
  methods: {
    getData() {
      //console.log('InstanceMapWidget', 'getData this.configItem = ', this.configItem);
      let options = this.configItem.chartAttr.widget.options;
      let productResourceInfosConsole = this.getProductResourceInfosConsoleParams(options);

      let objectType = '';
      if (
        options.objectType &&
        !this.notObjectItems[options.resourceType].includes(options.objectType)
      ) {
        objectType = options.objectType;
      }
      let body = {
        metricKey: options.metricKey,
        objectType: objectType,
        productResourceInfosConsole: productResourceInfosConsole
      };

      if (options.isK8sObjectType && !options.disableIndividualItem) {
        body.productSubName = options.objectItems.map((item) => item.key || item.value);
        body.productSubType = objectType;
        if (options.objects && options.objects.length) {
          body.objectType = options.objects[0].objectType;
        }
      }

      let header = Object.assign({ 'X-ResourceType': options.resourceType }, this.header);
      getWidgetData('post', this.configItem.chartAttr.widget.api, body, header).then((data) => {
        if (data instanceof Error) {
          return;
        }
        this.showChart = false;
        let lists = [];
        if (data.totalCount > 0) {
          let values = [];

          let _u = this.$util.getUnitInfo(data.contents);
          this.metricUnit = _u.metricUnit;
          if (this.metricUnit.unit == this.metricUnit.orgUnit) this.metricUnit.orgUnit = '';

          data.contents.forEach((item) => {
            let value = this.$util[_u.callFnc](item.perfData[0].value, ..._u.args).value;
            let _tooltip =
              item.productName +
              (item.objectDisplayName ? '.' + item.objectDisplayName : '') +
              '\n' +
              this.$filters.comma(value) +
              ' ' +
              this.metricUnit.unit +
              ' ' +
              this.metricUnit.orgUnit;
            lists.push({
              value: value,
              tooltip: _tooltip
            });
            values.push(value);
          });

          let _max = Math.max(...values);
          let _min = Math.min(...values);
          let _gap = 0;
          if (_max > 0 && _max - _min == 0) {
            _min = 0;
            _gap = _max / 5;
          } else {
            _gap = (_max - _min) / 5;
          }

          let legend = [];
          legend.push(_min);
          legend.push(_min + _gap);
          legend.push(_min + _gap * 2);
          legend.push(_min + _gap * 3);
          legend.push(_min + _gap * 4);
          this.legend = legend;

          this.showChart = true;
        }
        this.lists = lists;
      });
    }
  },
  computed: {
    opacity() {
      return (value) => {
        value = Number(value);
        if (value <= this.legend[1]) {
          return '0.2';
        } else if (value <= this.legend[2]) {
          return '0.4';
        } else if (value <= this.legend[3]) {
          return '0.6';
        } else if (value <= this.legend[4]) {
          return '0.8';
          // } else if (value <= this.legend[4]) {
          //     return '1';
        } else {
          return '1';
        }
      };
    },
    empty() {
      return this.$util.isEmpty(this.lists) || !this.isWidgetAuth;
    }
  },
  data() {
    return {
      lists: [],
      legend: [],
      metricUnit: {}
    };
  }
};
</script>

<style scoped lang="scss">
::v-deep .simplebar-horizontal {
  display: none;
}
.grid-box {
  margin: 0 -2px;
  width: calc(100% + 6px);
  &:after {
    content: '';
    clear: both;
    display: table;
  }
  .rect {
    float: left;
    height: 51px;
    width: 51px;
    border-radius: 2px;
    margin: 2px 2px;
    background-color: #79d6db;

    &.opt1 {
      opacity: 1;
    }
  }
}
.legend-box {
  &:after {
    content: '';
    clear: both;
    display: table;
  }
}
.legend {
  width: 20%;
  height: 10px;
  background-color: #79d6db;
}
.legendtxt {
  width: 20%;
  height: 10px;
  text-align: left;
  /* &:first-child {
        padding-left: 15px;
    } */
}
</style>
